import React, { Component } from 'react'
import { Stepper } from '@operations/shared';
import { bulkCreateHousingIqamaTemplate } from '../../utils/bulkSheetsTemplates';
import Confirmation from './confirmation';
import UploadHousingIqamaSheet from './uploadSheet';

class BulkCreateHousingIqamaRequests extends Component {
    state = {
        componentSteps: [
            {
                title: 'Upload Requests',
                content: <UploadHousingIqamaSheet validCols={bulkCreateHousingIqamaTemplate} />,
                id: 0,
            }, {
                title: 'Review & Confirm',
                content: <Confirmation />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <div className='bulkCreateProducts'>
                    <Stepper componentSteps={componentSteps} />
                </div>
            </>
        )
    }
}

export default BulkCreateHousingIqamaRequests
